import { render } from "./PuntoVentaCreate.vue?vue&type=template&id=b6a4febc&scoped=true"
import script from "./PuntoVentaCreate.vue?vue&type=script&lang=js"
export * from "./PuntoVentaCreate.vue?vue&type=script&lang=js"

import "./PuntoVentaCreate.vue?vue&type=style&index=0&id=b6a4febc&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a4febc"]])

export default __exports__